import React, { memo } from 'react';
import { ColorTokens, IconSizeTokens, IconTokens, StackType, StackAlignItems, StackJustifyContent, FontFamilyTokens, FontSizeTokens, SizeTypeTokens, BorderRadiusTokens, GradientColorTokens, IconAlignmentTokens, ShadowTypeTokens, } from '@voltmoney/schema';
import Stack from '../stack/Stack';
import Typography from '../typography/Typography';
import Space from '../space/Space';
import Card from '../card/Card';
import { View } from 'react-native';
/**
 * Primary UI component for user interaction
 */
const AmountCardBase = ({ id, title, isDarkMode, margin = {
    horizontal: SizeTypeTokens.XXL,
    bottom: SizeTypeTokens.XXL,
}, shadow = ShadowTypeTokens.E2, subTitle, gradientColor = GradientColorTokens.IB_7, chipText, icon = {
    name: IconTokens.Info,
    size: IconSizeTokens.XS,
    align: IconAlignmentTokens.left,
}, }) => {
    return (React.createElement(Card, { bgColor: isDarkMode ? ColorTokens.DARK_MODE : ColorTokens.White, borderRadius: BorderRadiusTokens.BR4, shadow: shadow, body: {
            children: [
                React.createElement(Stack, { type: StackType.row, padding: margin, alignItems: StackAlignItems.flexStart, justifyContent: StackJustifyContent.flexStart },
                    React.createElement(Stack, null,
                        React.createElement(Typography, { label: title, fontFamily: FontFamilyTokens.Inter, fontWeight: '400', fontSize: FontSizeTokens.XS, color: ColorTokens.Grey_Smoke }),
                        React.createElement(Space, { size: SizeTypeTokens.SM }),
                        React.createElement(Stack, { type: StackType.row, alignItems: StackAlignItems.center, justifyContent: StackJustifyContent.center },
                            React.createElement(Typography, { label: '₹', fontFamily: FontFamilyTokens.Inter, fontWeight: '700', fontSize: FontSizeTokens.XXXXL, color: ColorTokens.Grey_Charcoal }),
                            React.createElement(Space, { size: SizeTypeTokens.SM }),
                            React.createElement(Typography, { id: id, label: subTitle, fontFamily: FontFamilyTokens.Poppins, fontWeight: '700', fontSize: FontSizeTokens.XXXXL, color: ColorTokens.Grey_Charcoal }))),
                    React.createElement(Stack, { alignItems: StackAlignItems.flexEnd, justifyContent: StackJustifyContent.flexEnd },
                        React.createElement(View, { style: {
                                alignItems: 'center',
                            } },
                            React.createElement(View, { style: {
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                } },
                                React.createElement(Space, { size: SizeTypeTokens.SM }),
                                React.createElement(Typography, { label: chipText, fontFamily: FontFamilyTokens.Inter, fontWeight: '500', fontSize: FontSizeTokens.XS, color: ColorTokens.Grey_Charcoal }))),
                        React.createElement(Space, { size: SizeTypeTokens.XXXXXXL }),
                        React.createElement(Space, { size: SizeTypeTokens.XXXXL }),
                        React.createElement(Space, { size: SizeTypeTokens.XXXXL }))),
            ],
        } }));
};
export default memo(AmountCardBase);
export { AmountCardBase };
